module.exports = __webpack_public_path__ + "img/loader-bike.943b6e9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/loader-bike.gif
// module id = IPPB
// module chunks = 70